import { V as VisibilityMode } from '../../../../../common.gen-CZ1M9G8L.js';

const pluginVersion = "12.1.0-pre";
const defaultOptions = {
  alignValue: "left",
  mergeValues: true,
  perPage: 20,
  rowHeight: 0.9,
  showValue: VisibilityMode.Auto
};
const defaultFieldConfig = {
  fillOpacity: 70,
  lineWidth: 0
};

export { defaultFieldConfig, defaultOptions, pluginVersion };
